var app = angular.module("leonardo");

var LoginRedirection = function($stateProvider) {
  $stateProvider.state('login-redirection', {
    url: "/login-redirection",
    parent: 'authenticated.layout-main',
    ncyBreadcrumb: {
      skip: true
    },
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': {
        controller: ['$scope', 'LoginService', function($scope, LoginService) {
          $scope.$on('auth-data:updated', function (event, authData) {
            LoginService.redirect(authData);
          });
        }],
        template: '',
      }
    }
  });

  $stateProvider.state('login-redirection-work-as', {
    url: "/login-redirection-work-as",
    parent: 'authenticated.layout-main',
    ncyBreadcrumb: {
      skip: true
    },
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': {
        controller: ['AuthDataService', 'LoginService', '$timeout', '$rootScope',  function(AuthDataService, LoginService, $timeout, $rootScope) {
          AuthDataService.getData().then(function(authData) {
            $timeout(function () {
              $rootScope.$broadcast('auth-data:updated', authData);
              LoginService.redirect(authData);
            }, 0);
          });
        }],
        template: ''
      }
    }
  });

  $stateProvider.state('logout', {
    url: "/logout",
    parent: 'authenticated.layout-main',
    ncyBreadcrumb: {
      skip: true
    },
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': {
        controller: ['AuthService',
          function(AuthService) {
            AuthService.logout();
        }],
        template: ''
      }
    }
  });
};

app.config(['$stateProvider', '$urlRouterProvider', LoginRedirection]);
